import * as React from 'react'

import { Title, Visible } from 'main/ui'
import {
  BodyText,
  IconContainer,
  MainContainer,
  Synopsis,
  TableContainer,
  TableRowContainer,
  WhenText,
} from './CalendarTableSection.styles'
import Icon, { IconKind } from './Icon'

export interface IEntry {
  when: string
  body: string
}

interface IProps {
  title: string
  borderColor: string
  color: string
  icon: IconKind
  synopsis: string | null
  entries: IEntry[]
}

export default function CalendarTableSection(props: IProps) {
  const { borderColor, color, entries, icon, synopsis, title } = props

  return (
    <div>
      <Title kind="large">{title}</Title>
      <MainContainer>
        <Visible lg xl>
          <IconContainer>
            <Icon color={color} kind={icon} />
          </IconContainer>
        </Visible>
        <TableContainer>
          {entries.map((entry, i) => (
            <TableRowContainer key={i} borderColor={borderColor}>
              <WhenText css={{ color }}>{entry.when}</WhenText>
              <BodyText muted>{entry.body}</BodyText>
            </TableRowContainer>
          ))}
          {synopsis && <Synopsis muted>{synopsis}</Synopsis>}
        </TableContainer>
      </MainContainer>
    </div>
  )
}
